import { useState, useEffect, useRef } from 'react';

/**
 * useFetch(fnFactory, deps)
 *
 * fnFactory: a function that returns a Promise (e.g. () => getSiteSettings())
 * deps: dependency array for useEffect (re-fetches when deps change)
 *
 * Returns { data, loading, error }
 */
function useFetch(fnFactory, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    setLoading(true);
    setError(null);

    fnFactory()
      .then((result) => {
        if (mountedRef.current) {
          setData(result);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (mountedRef.current) {
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error };
}

export default useFetch;
